import {postRequest} from '../../../../../middlewares/api/actions';
import {getUploadFileOnServerUrl} from '../../../../../constants/urls';
import {submitPluginInputFiles} from "../../../../utilities/plugins/actions";

export const FILE_MAPPING_WIZARD_CSV_FORM_CHANGE = 'FILE_MAPPING_WIZARD_CSV_FORM_CHANGE';
export const FILE_MAPPING_WIZARD_CSV_FORM_FILE_FORMAT_SET = 'FILE_MAPPING_WIZARD_CSV_FORM_FILE_FORMAT_SET';
export const FILE_MAPPING_WIZARD_CSV_FORM_SUBMIT = 'FILE_MAPPING_WIZARD_CSV_FORM_SUBMIT';
export const FILE_MAPPING_WIZARD_PLUGIN_FORM_SUBMIT = 'FILE_MAPPING_WIZARD_PLUGIN_FORM_SUBMIT';

export const changeFileMappingWizardCsvForm = fields => ({
  type: FILE_MAPPING_WIZARD_CSV_FORM_CHANGE,
  fields
});

export const setFileMappingWizardCsvFormFileFormat = fileFormat => ({
  type: FILE_MAPPING_WIZARD_CSV_FORM_FILE_FORMAT_SET,
  fileFormat
});

export const submitFileMappingWizardCsvForm = (file) => {

  let fileFormData = new FormData();
  fileFormData.append('file', file);

  return postRequest(
    FILE_MAPPING_WIZARD_CSV_FORM_SUBMIT,
    getUploadFileOnServerUrl(),
    fileFormData,
    t => ({
      start: t('scenes.dataManager.fileMapping.wizard.csvForm.messages.submit.start'),
      success: t("scenes.dataManager.fileMapping.wizard.csvForm.messages.submit.success")
    })
  );
};

export const submitPluginFileMappingWizardFiles = (cubeId, pluginUid, file, transformFile, processFile) => submitPluginInputFiles(pluginUid, file, transformFile, processFile, FILE_MAPPING_WIZARD_PLUGIN_FORM_SUBMIT, cubeId);